<template>
  <div class="checknyApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" :style="'min-height:'+curHeight+'px'">
    <div class="commen">
      <h2>
        <div class="ctitle">Journal Verification Center</div>
      </h2>
      <ul class="qkan">
        <li @click="$router.push('cdetail?id='+item.id)" v-for="(item,i) in setQkanIndex">
          <div class="title">
            <img :src="baseUrl+item.image" >
            <div class="conTitle">
              <span>{{item.title}}
                <font :style="item.status == 1 ? '' : item.status == 2 ? 'color:green' : 'color:red'">{{item.status == 1 ? 'Under Review' : item.status == 2 ? 'Review Approved' : 'Review Rejected'}} <a>{{item.status == 1 ? 'Review Now' : 'View Journal'}}<i class="el-icon-arrow-right"></i></a></font>
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setQkanIndex:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getQkanIndex();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getQkanIndex:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/qkan',
          dataType:'json',
          success:function(data){
            that.setQkanIndex = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .checknyApp .el-message-box{
    width:30%
  }
  .checknyApp{
    max-width:750px;
    margin:0 auto;
    background:#fff;
  }
  
  .checknyApp .commen ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  
  .checknyApp .commen{
    background:#fff;
    width:100%;
  }
  .checknyApp .commen h2{
    margin:0 auto;
    font-size:16px;
    padding:15px 0;
    border-bottom:solid 1px #f5f5f5;
  }
  .checknyApp .commen h2 .ctitle{
    width:92%;
    margin:0 auto;
    position:relative;
    padding-left:2%;
  }
  .checknyApp .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-top:2px
  }
  
  .checknyApp .commen .qkan li{
    width:92%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .checknyApp .commen .qkan li .title{
    position:relative;
    width:100%;
  }
  .checknyApp .commen .qkan li .title img{
    float:left;
    width:30%;
    border-radius:6px;
    object-fit: cover;
    height:140px
  }
  .checknyApp .commen .qkan li .title .conTitle{
    float:left;
    width:67%;
    margin-left:3%;
    height:140px;
    position: relative;
  }
  .checknyApp .commen .qkan li .title .conTitle span{
    display:block;
    color:#333333;
    width:100%;
    overflow: hidden;
    font-size:15px;
    font-weight: bold;
    line-height:24px;
    position: absolute;
    top:50%;
    transform: translateY(-50%);
  }
  .checknyApp .commen .qkan li .title .conTitle font{
    display:block;
    padding-top:8px;
    color:#0052D9
  }
  .checknyApp .commen .qkan li .title .conTitle a{
    color:#fff;
    background: #0052D9;
    border-radius: 3px 3px 3px 3px;
    font-size:14px;
    display:inline-block;
    padding:0 4px 0 8px;
    float:right;
    border:solid 1px #0052D9;
    font-size:13px
  }
  .checknyApp .commen .qkan li .title .conTitle a.curt{
    background:#fff;
    color:#0052D9
  }
</style>